import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useAuthDataContext } from "components/auth";
import SelectComponent from "./SelectComponent";
import { getRoomTemplatesService } from "../../services/commonService";

const TemplateSelect = ({
  id = "roomTemplateId",
  name = "roomTemplateId",
  contractId,
  label,
  value,
  handleChange,
  includeTestTemplates,
  disabled = false,
}) => {
  const { hasAdminPrivileges } = useAuthDataContext();
  const [roomTemplates, setRoomTemplates] = useState([]);
  const previousContractId = useRef(contractId);

  useEffect(
    () => {
      if (!contractId) {
        setRoomTemplates([]);
        return;
      }
      getRoomTemplatesService(contractId, hasAdminPrivileges && includeTestTemplates, setRoomTemplates, () =>
        setRoomTemplates([]),
      );
    },
    [contractId, hasAdminPrivileges, includeTestTemplates],
  );

  // Igual que la versión GraphQL: se limpia la plantilla seleccionada en cualquier
  // cambio de contrato, no solo al vaciarlo.
  useEffect(
    () => {
      if (contractId !== previousContractId.current) {
        previousContractId.current = contractId;
        handleChange({ target: { value: undefined } });
      }
    },
    [contractId, handleChange],
  );

  return (
    <SelectComponent
      disabled={disabled || !contractId}
      id={id}
      name={name}
      label={label}
      value={value}
      handleChange={handleChange}
      elements={roomTemplates}
      getValueFromElement={item => item._id}
      getLabelFromElement={item => item.codename}
      itemKey="_id"
      itemValue="_id"
      itemLabel="codename"
    />
  );
};

TemplateSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  /**
   * Contrato para el que se mostrarán las plantillas
   */
  contractId: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  label: PropTypes.string,
  /**
   * Indica si se incluyen las plantillas de test
   */
  includeTestTemplates: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default TemplateSelect;
